// This device's identity for punching. A random id kept in the browser: the
// server binds each colaborador to their own device(s). A kiosk (shared
// device on site registered by gerência) also keeps its secret token here.
const DEVICE_KEY = "maxcei-portal-device";
const KIOSK_KEY = "maxcei-portal-kiosk";

const read = (key: string) => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const getDeviceId = (): string => {
  let id = read(DEVICE_KEY);

  if (!id) {
    id = crypto.randomUUID();

    try {
      window.localStorage.setItem(DEVICE_KEY, id);
    } catch {
      // private mode: a new id each visit (needs gerência approval each time)
    }
  }

  return id;
};

export const getKioskToken = (): string | null => read(KIOSK_KEY);

export const setKioskToken = (token: string | null) => {
  try {
    if (token) {
      window.localStorage.setItem(KIOSK_KEY, token);
    } else {
      window.localStorage.removeItem(KIOSK_KEY);
    }
  } catch {
    // ignore
  }
};
